/**
 * クロス設定登録画面 Pコード商品情報取得(リクエストパラメータ)用クラス
 *
 * @export PcodeGoodsInfoList
 * @class PcodeGoodsInfoList
 */
export class PcodeGoodsInfoList {
  /** Pコード */
  public pCode = String('');
}
